import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { KpisSection } from "@/features/fermentation-journal/components/results";

export const Route = createFileRoute("/fermentations/$group_id/results/kpis")({
  component: KpisPage,
});

function KpisPage() {
  const { group_id } = Route.useParams();
  const groupId = Number(group_id) as FermentationGroupId;

  return (
    <div className="max-w-7xl">
      <KpisSection groupId={groupId} />
    </div>
  );
}
